module.exports = __webpack_public_path__ + "philips.28339d23468d8d921d3a.png";